/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// reactstrap components
import { Container, Row, Col } from 'reactstrap';

// core components
import AuthFooter from 'components/Footers/AuthFooter.js';

import routes from 'routes.js';

import tdcHubLogo from 'assets/img/tdc/logo_white.png';

class SignUp extends React.Component {
  componentDidMount() {
    document.body.classList.add('bg-dark');
  }
  componentWillUnmount() {
    document.body.classList.remove('bg-dark');
  }
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/signup') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <>
        <div className="bg-dark main-content">
          <div className="header bg-gradient-warning py-7 py-lg-8">
            <Container>
              <div className="header-body text-center mb-6">
                <Row className="justify-content-center">
                  <Col lg="5" md="6">
                    <img
                      style={{ maxWidth: '50%' }}
                      src={tdcHubLogo}
                      alt="TDC Hub Logo"
                    />
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-dark stroke-dark"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </div>
          {/* Page content */}
          <Container className="bg-dark mt--8 pb-5">
            <Row className="justify-content-center">
              <Switch>
                {this.getRoutes(routes)}
                <Redirect from="*" to="/signup/emailverify" />
              </Switch>
            </Row>
          </Container>
        </div>
        <AuthFooter />
      </>
    );
  }
}

export default SignUp;
